import React from "react";
import ReactDOM from 'react-dom';

import { modal } from './machine_app_modal';
import { controlCenter } from "@ventionco/mm-machine-logic-robot";
import * as THREE from "three";

const { view: RobotJogger } = controlCenter;

const jointLimits = [
  { min: -180,  max: 180, },
  { min: -180,  max: 180, },
  { min: -180,  max: 180, },
  { min: -180,  max: 180, },
  { min: -180,  max: 180, },
  { min: -180,  max: 180, },
];

export const getRobotJoggerModal = (pMachineLogicLibrary, pRobotType, { onClose = undefined, onTeach = undefined, closeButtonLabel = "Teach position" } = {}) => {
  const { selectors } = pMachineLogicLibrary.robotAppsService;

  const lJoggerModal = modal({ onClose, closeOnOutsideClick: true });
  const lJoggerContainer = document.createElement('div');

  renderRobotJogger(selectors, lJoggerModal, lJoggerContainer, closeButtonLabel, pRobotType, onTeach);
  selectors.getRobotAppsService().send("RobotInstructionEditable/START");

  lJoggerModal.content.append(lJoggerContainer);
  lJoggerModal.show();
  return lJoggerModal;
};

function renderRobotJogger(selectors, pJoggerModal, pJoggerContainer, pCloseButtonLabel, pRobotType, pOnTeach = undefined) {
  const lRobotAppsService = selectors.getRobotAppsService();

  const lRender = (pOnTeach) => {
    const lReactJogger = React.createElement(RobotJogger, {
      robotType: pRobotType,
      jointLimits,
      position: getPosition(),
      rotation: getRotation(),
      jointAngles: getJointAngles(),
      joggerSpeedPercentage: selectors.getJoggerSpeedPercentage(),
      onJoggerPoseTranslationMouseDown: (letter, value) => lRobotAppsService.send("RobotInstructionEditable/onJoggerPoseTranslationMouseDown", { letter, value }),
      onJoggerPoseRotationMouseDown: (letter, value) => lRobotAppsService.send("RobotInstructionEditable/onJoggerPoseRotationMouseDown", { letter, value }),
      onJoggerJointArrowMouseDown: (index, delta) => lRobotAppsService.send("RobotInstructionEditable/onJoggerJointArrowMouseDown", { index, delta }),
      onJoggerArrowMouseUp: () => lRobotAppsService.send("RobotInstructionEditable/onJoggerArrowMouseUp"),
      onSpeedSliderChange: (joggerSpeedPercentage) => lRobotAppsService.send("RobotInstructionEditable/JOGGER_SPEED_SLIDER_CHANGED", { joggerSpeedPercentage }),
      onTeachWaypointAndCloseButtonClick: () => {
        lRobotAppsService.send("RobotInstructionEditable/STOP");
        pJoggerModal.hide();

        if (pOnTeach) {
          pOnTeach(getTaughtPosition());
        }
      },
      teachWaypointAndCloseButtonText: pCloseButtonLabel,
    });

    ReactDOM.render(lReactJogger, pJoggerContainer);
  };

  const lOnTeach = (pTaughtPosition) => {
    if (pOnTeach) {
      pOnTeach(pTaughtPosition);
    }

    clearInterval(lUpdateInterval);
  };

  // Periodically update the component to see the changing state
  lRender(lOnTeach);
  const lUpdateInterval = setInterval(() => lRender(lOnTeach), 100);
}

function getPosition(selectors) {
  const position = selectors.getRobotCartesianPositionInMM();

  return {
    mP: {
      x: position?.x || 0,
      y: position?.y || 0,
      z: position?.z || 0,
    }
  };
}

function getRotation(selectors) {
  const rotation = selectors.getRobotCartesianRotationInDeg();

  return {
    mP: {
      x: rotation?.x || 0,
      y: rotation?.y || 0,
      z: rotation?.z || 0,
      w: rotation?.w || 0,
    }
  };
}

function getJointAngles(selectors) {
  return selectors.getRobotJointStatesInDeg() || [0, 0, 0, 0, 0, 0];
}

function getTaughtPosition(selectors) {
  const { position, rotation } = selectors.getRobotStateCartesianPoseInMM();

  return {
    pose: cartesianPoseTo3DTransformationMatrix([...position.toArray(), ...rotation.toArray()]),
    jointAngles: getJointAngles(), // [j1, j2, j3, j4, j5, j6, ...]
  };
}

/**
 * Takes a cartesian pose array and turn it into an array representing a 3D transformation matrix
 * @param {(number)[]} pCartesianPose - The [x (mm), y (mm), z (mm), qx, qy, qz, qw] cartesian pose
 */
export function cartesianPoseTo3DTransformationMatrix(pCartesianPose) {
  const [x, y, z, qx, qy, qz, qw] = pCartesianPose;

  const lPosition = new THREE.Vector3(x, y, z);
  const lQuaternion = new THREE.Quaternion(qx, qy, qz, qw);
  const lScale = new THREE.Vector3(1, 1, 1); // Unit vector, no scaling (The parameter is required)

  return new THREE.Matrix4().compose(lPosition, lQuaternion, lScale).toArray();
}
